// You can write more code here

/* START OF COMPILED CODE */

import UIBlocker from "../../prefabs/GeneralUI/UIBlocker";
import DefaultButton from "../../prefabs/GeneralUI/Buttons/DefaultButton";
import DefaultConfirmButton_m from "../../prefabs/DefaultConfirmButton_m";
/* START-USER-IMPORTS */
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { getSceneManager } from '@/game/GameComponents/PhaserGame/Managers/SceneManager';
import { DEFAULT_SCALE_DOWN_CONFIG } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/ResponsivenessManagerTypes';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import { WalkthroughController } from '@/game/GameComponents/PhaserGame/Utils/WalkthroughController';
/* END-USER-IMPORTS */

export default class AssessmentWalkthroughPanel extends Phaser.Scene {

	constructor() {
		super("AssessmentWalkthroughPanel");

		/* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
	}

	editorCreate(): void {

		// mainContainer
		const mainContainer = this.add.container(0, 0);

		// desktopView
		const desktopView = this.add.container(0, 0);
		desktopView.visible = false;
		mainContainer.add(desktopView);

		// assessmentWalkthroughPanel
		const assessmentWalkthroughPanel = this.add.container(0, 0);
		desktopView.add(assessmentWalkthroughPanel);

		// uIBlocker
		const uIBlocker = new UIBlocker(this, 0, 0);
		uIBlocker.visible = true;
		assessmentWalkthroughPanel.add(uIBlocker);

		// greenleaf
		const greenleaf = this.add.image(1444, 664, "npc_mentor_e_portrait");
		greenleaf.scaleX = 0.4;
		greenleaf.scaleY = 0.4;
		assessmentWalkthroughPanel.add(greenleaf);

		// interactiveOverlay
		const interactiveOverlay = this.add.image(0, 0, "1x1sprite");
		interactiveOverlay.scaleX = 1024;
		interactiveOverlay.scaleY = 768;
		interactiveOverlay.setOrigin(0, 0);
		interactiveOverlay.alpha = 0.001;
		interactiveOverlay.alphaTopLeft = 0.001;
		interactiveOverlay.alphaTopRight = 0.001;
		interactiveOverlay.alphaBottomLeft = 0.001;
		interactiveOverlay.alphaBottomRight = 0.001;
		assessmentWalkthroughPanel.add(interactiveOverlay);

		// topRightOverlays
		const topRightOverlays = this.add.container(1600, 0);
		assessmentWalkthroughPanel.add(topRightOverlays);

		// walkthroughPanel_4
		const walkthroughPanel_4 = this.add.container(0, 0);
		topRightOverlays.add(walkthroughPanel_4);

		// audioButton_3
		const audioButton_3 = this.add.image(-80, 64, "exit1-reveal_32");
		audioButton_3.scaleX = 2;
		audioButton_3.scaleY = 2;
		walkthroughPanel_4.add(audioButton_3);

		// guidanceArrow_2
		const guidanceArrow_2 = this.add.image(-80, 132, "GuidanceArrow-Small");
		guidanceArrow_2.scaleX = 4;
		guidanceArrow_2.scaleY = 4;
		walkthroughPanel_4.add(guidanceArrow_2);

		// labelContainer_7
		const labelContainer_7 = this.add.container(-80, 164);
		walkthroughPanel_4.add(labelContainer_7);

		// textBacking_7
		const textBacking_7 = this.add.nineslice(0, 2, "fadeOut2", undefined, 28, 0, 3, 3, 0, 0);
		textBacking_7.scaleX = 4;
		textBacking_7.scaleY = 32;
		textBacking_7.setOrigin(0.5, 0);
		textBacking_7.alpha = 0.5;
		textBacking_7.tint = 3023407;
		labelContainer_7.add(textBacking_7);

		// dailiesLabel_m_7
		const dailiesLabel_m_7 = this.add.bitmapText(0, 0, "Aronui", "Quit");
		dailiesLabel_m_7.setOrigin(0.5, 0);
		dailiesLabel_m_7.tintTopLeft = 15130076;
		dailiesLabel_m_7.tintTopRight = 15130076;
		dailiesLabel_m_7.tintBottomLeft = 15130076;
		dailiesLabel_m_7.tintBottomRight = 15130076;
		dailiesLabel_m_7.text = "Quit";
		dailiesLabel_m_7.fontSize = -28;
		labelContainer_7.add(dailiesLabel_m_7);

		// walkthroughPanel_5
		const walkthroughPanel_5 = this.add.container(0, 0);
		topRightOverlays.add(walkthroughPanel_5);

		// audioButton_4
		const audioButton_4 = this.add.image(-152, 64, "help-reveal_32");
		audioButton_4.scaleX = 2;
		audioButton_4.scaleY = 2;
		walkthroughPanel_5.add(audioButton_4);

		// guidanceArrow_3
		const guidanceArrow_3 = this.add.image(-152, 132, "GuidanceArrow-Small");
		guidanceArrow_3.scaleX = 4;
		guidanceArrow_3.scaleY = 4;
		walkthroughPanel_5.add(guidanceArrow_3);

		// labelContainer_8
		const labelContainer_8 = this.add.container(-152, 164);
		walkthroughPanel_5.add(labelContainer_8);

		// textBacking_8
		const textBacking_8 = this.add.nineslice(0, 2, "fadeOut2", undefined, 36, 0, 3, 3, 0, 0);
		textBacking_8.scaleX = 4;
		textBacking_8.scaleY = 32;
		textBacking_8.setOrigin(0.5, 0);
		textBacking_8.alpha = 0.5;
		textBacking_8.tint = 3023407;
		labelContainer_8.add(textBacking_8);

		// dailiesLabel_m_8
		const dailiesLabel_m_8 = this.add.bitmapText(0, 0, "Aronui", "Help");
		dailiesLabel_m_8.setOrigin(0.5, 0);
		dailiesLabel_m_8.tintTopLeft = 15130076;
		dailiesLabel_m_8.tintTopRight = 15130076;
		dailiesLabel_m_8.tintBottomLeft = 15130076;
		dailiesLabel_m_8.tintBottomRight = 15130076;
		dailiesLabel_m_8.text = "Help";
		dailiesLabel_m_8.fontSize = -28;
		labelContainer_8.add(dailiesLabel_m_8);

		// walkthroughPanel_6
		const walkthroughPanel_6 = this.add.container(0, 0);
		topRightOverlays.add(walkthroughPanel_6);

		// audioButton_5
		const audioButton_5 = this.add.image(-224, 64, "keyboard-click-reveal_32");
		audioButton_5.scaleX = 2;
		audioButton_5.scaleY = 2;
		walkthroughPanel_6.add(audioButton_5);

		// guidanceArrow_6
		const guidanceArrow_6 = this.add.image(-226, 132, "GuidanceArrow-Small");
		guidanceArrow_6.scaleX = 4;
		guidanceArrow_6.scaleY = 4;
		walkthroughPanel_6.add(guidanceArrow_6);

		// labelContainer_9
		const labelContainer_9 = this.add.container(-226, 164);
		walkthroughPanel_6.add(labelContainer_9);

		// textBacking_9
		const textBacking_9 = this.add.nineslice(0, 2, "fadeOut2", undefined, 64, 0, 3, 3, 0, 0);
		textBacking_9.scaleX = 4;
		textBacking_9.scaleY = 32;
		textBacking_9.setOrigin(0.5, 0);
		textBacking_9.alpha = 0.5;
		textBacking_9.tint = 3023407;
		labelContainer_9.add(textBacking_9);

		// dailiesLabel_m_9
		const dailiesLabel_m_9 = this.add.bitmapText(0, 0, "Aronui", "Switch Controls");
		dailiesLabel_m_9.setOrigin(0.5, 0);
		dailiesLabel_m_9.tintTopLeft = 15130076;
		dailiesLabel_m_9.tintTopRight = 15130076;
		dailiesLabel_m_9.tintBottomLeft = 15130076;
		dailiesLabel_m_9.tintBottomRight = 15130076;
		dailiesLabel_m_9.text = "Switch Controls";
		dailiesLabel_m_9.fontSize = -28;
		labelContainer_9.add(dailiesLabel_m_9);

		// boardOverlays
		const boardOverlays = this.add.container(800, 1024);
		assessmentWalkthroughPanel.add(boardOverlays);

		// walkthroughPanel_3
		const walkthroughPanel_3 = this.add.container(-800, -1024);
		boardOverlays.add(walkthroughPanel_3);

		// audioButton_6
		const audioButton_6 = this.add.image(728, 968, "ui-speak-button");
		audioButton_6.scaleX = 4;
		audioButton_6.scaleY = 4;
		walkthroughPanel_3.add(audioButton_6);

		// guidanceArrow_7
		const guidanceArrow_7 = this.add.image(728, 896, "GuidanceArrow-Small");
		guidanceArrow_7.scaleX = 4;
		guidanceArrow_7.scaleY = 4;
		guidanceArrow_7.flipY = true;
		walkthroughPanel_3.add(guidanceArrow_7);

		// labelContainer_13
		const labelContainer_13 = this.add.container(728, 832);
		walkthroughPanel_3.add(labelContainer_13);

		// textBacking_13
		const textBacking_13 = this.add.nineslice(0, 2, "fadeOut2", undefined, 92, 0, 3, 3, 0, 0);
		textBacking_13.scaleX = 4;
		textBacking_13.scaleY = 32;
		textBacking_13.setOrigin(0.5, 0);
		textBacking_13.alpha = 0.5;
		textBacking_13.tint = 3023407;
		labelContainer_13.add(textBacking_13);

		// dailiesLabel_m_13
		const dailiesLabel_m_13 = this.add.bitmapText(0, 0, "Aronui", "Hear Word in Sentence");
		dailiesLabel_m_13.setOrigin(0.5, 0);
		dailiesLabel_m_13.tintTopLeft = 15130076;
		dailiesLabel_m_13.tintTopRight = 15130076;
		dailiesLabel_m_13.tintBottomLeft = 15130076;
		dailiesLabel_m_13.tintBottomRight = 15130076;
		dailiesLabel_m_13.text = "Hear Word in Sentence";
		dailiesLabel_m_13.fontSize = -28;
		labelContainer_13.add(dailiesLabel_m_13);

		// walkthroughPanel_2
		const walkthroughPanel_2 = this.add.container(-800, -1024);
		walkthroughPanel_2.visible = false;
		boardOverlays.add(walkthroughPanel_2);

		// audioButton_7
		const audioButton_7 = this.add.image(800, 968, "ui-definition-button");
		audioButton_7.scaleX = 4;
		audioButton_7.scaleY = 4;
		walkthroughPanel_2.add(audioButton_7);

		// guidanceArrow_8
		const guidanceArrow_8 = this.add.image(800, 896, "GuidanceArrow-Small");
		guidanceArrow_8.scaleX = 4;
		guidanceArrow_8.scaleY = 4;
		guidanceArrow_8.flipY = true;
		walkthroughPanel_2.add(guidanceArrow_8);

		// labelContainer_10
		const labelContainer_10 = this.add.container(800, 832);
		walkthroughPanel_2.add(labelContainer_10);

		// textBacking_10
		const textBacking_10 = this.add.nineslice(0, 2, "fadeOut2", undefined, 64, 0, 3, 3, 0, 0);
		textBacking_10.scaleX = 4;
		textBacking_10.scaleY = 32;
		textBacking_10.setOrigin(0.5, 0);
		textBacking_10.alpha = 0.5;
		textBacking_10.tint = 3023407;
		labelContainer_10.add(textBacking_10);

		// dailiesLabel_m_10
		const dailiesLabel_m_10 = this.add.bitmapText(0, 0, "Aronui", "Hear Definition");
		dailiesLabel_m_10.setOrigin(0.5, 0);
		dailiesLabel_m_10.tintTopLeft = 15130076;
		dailiesLabel_m_10.tintTopRight = 15130076;
		dailiesLabel_m_10.tintBottomLeft = 15130076;
		dailiesLabel_m_10.tintBottomRight = 15130076;
		dailiesLabel_m_10.text = "Hear Definition";
		dailiesLabel_m_10.fontSize = -28;
		labelContainer_10.add(dailiesLabel_m_10);

		// walkthroughPanel_1
		const walkthroughPanel_1 = this.add.container(-800, -1024);
		walkthroughPanel_1.visible = false;
		boardOverlays.add(walkthroughPanel_1);

		// audioButton_8
		const audioButton_8 = this.add.image(880, 968, "ui-repeat-button");
		audioButton_8.scaleX = 4;
		audioButton_8.scaleY = 4;
		walkthroughPanel_1.add(audioButton_8);

		// guidanceArrow_9
		const guidanceArrow_9 = this.add.image(880, 896, "GuidanceArrow-Small");
		guidanceArrow_9.scaleX = 4;
		guidanceArrow_9.scaleY = 4;
		guidanceArrow_9.flipY = true;
		walkthroughPanel_1.add(guidanceArrow_9);

		// labelContainer_11
		const labelContainer_11 = this.add.container(880, 832);
		walkthroughPanel_1.add(labelContainer_11);

		// textBacking_11
		const textBacking_11 = this.add.nineslice(0, 2, "fadeOut2", undefined, 54, 0, 3, 3, 0, 0);
		textBacking_11.scaleX = 4;
		textBacking_11.scaleY = 32;
		textBacking_11.setOrigin(0.5, 0);
		textBacking_11.alpha = 0.5;
		textBacking_11.tint = 3023407;
		labelContainer_11.add(textBacking_11);

		// dailiesLabel_m_11
		const dailiesLabel_m_11 = this.add.bitmapText(0, 0, "Aronui", "Repeat Word");
		dailiesLabel_m_11.setOrigin(0.5, 0);
		dailiesLabel_m_11.tintTopLeft = 15130076;
		dailiesLabel_m_11.tintTopRight = 15130076;
		dailiesLabel_m_11.tintBottomLeft = 15130076;
		dailiesLabel_m_11.tintBottomRight = 15130076;
		dailiesLabel_m_11.text = "Repeat Word";
		dailiesLabel_m_11.fontSize = -28;
		labelContainer_11.add(dailiesLabel_m_11);

		// walkthroughPanel
		const walkthroughPanel = this.add.container(-800, -1024);
		boardOverlays.add(walkthroughPanel);

		// guidanceArrow_10
		const guidanceArrow_10 = this.add.image(800, 840, "GuidanceArrow-Small");
		guidanceArrow_10.scaleX = 4;
		guidanceArrow_10.scaleY = 4;
		guidanceArrow_10.flipY = true;
		walkthroughPanel.add(guidanceArrow_10);

		// image_1
		const image_1 = this.add.image(800, 908, "default-button-confirm");
		image_1.scaleX = 2;
		image_1.scaleY = 2;
		walkthroughPanel.add(image_1);

		// submitLabel
		const submitLabel = this.add.bitmapText(800, 908, "Aronui", "Submit");
		submitLabel.setOrigin(0.5, 0.5);
		submitLabel.tintTopLeft = 15130076;
		submitLabel.tintTopRight = 15130076;
		submitLabel.tintBottomLeft = 15130076;
		submitLabel.tintBottomRight = 15130076;
		submitLabel.text = "Submit";
		submitLabel.fontSize = -14;
		walkthroughPanel.add(submitLabel);

		// labelContainer_12
		const labelContainer_12 = this.add.container(800, 776);
		walkthroughPanel.add(labelContainer_12);

		// textBacking_12
		const textBacking_12 = this.add.nineslice(0, 2, "fadeOut2", undefined, 54, 0, 3, 3, 0, 0);
		textBacking_12.scaleX = 4;
		textBacking_12.scaleY = 32;
		textBacking_12.setOrigin(0.5, 0);
		textBacking_12.alpha = 0.5;
		textBacking_12.tint = 3023407;
		labelContainer_12.add(textBacking_12);

		// dailiesLabel_m_12
		const dailiesLabel_m_12 = this.add.bitmapText(0, 0, "Aronui", "Submit Word");
		dailiesLabel_m_12.setOrigin(0.5, 0);
		dailiesLabel_m_12.tintTopLeft = 15130076;
		dailiesLabel_m_12.tintTopRight = 15130076;
		dailiesLabel_m_12.tintBottomLeft = 15130076;
		dailiesLabel_m_12.tintBottomRight = 15130076;
		dailiesLabel_m_12.text = "Submit Word";
		dailiesLabel_m_12.fontSize = -28;
		labelContainer_12.add(dailiesLabel_m_12);

		// continueButtonContainer
		const continueButtonContainer = this.add.container(1600, 1024);
		assessmentWalkthroughPanel.add(continueButtonContainer);

		// continueButton
		const continueButton = new DefaultButton(this, -120, -48);
		continueButtonContainer.add(continueButton);

		// mobileView
		const mobileView = this.add.container(0, 0);
		mainContainer.add(mobileView);

		// assessmentWalkthroughPanel_m
		const assessmentWalkthroughPanel_m = this.add.container(0, 0);
		mobileView.add(assessmentWalkthroughPanel_m);

		// uIBlocker_m
		const uIBlocker_m = new UIBlocker(this, 0, 0);
		uIBlocker_m.visible = true;
		assessmentWalkthroughPanel_m.add(uIBlocker_m);

		// greenleaf_m
		const greenleaf_m = this.add.image(152, 368, "npc_mentor_e_portrait");
		greenleaf_m.scaleX = 0.4;
		greenleaf_m.scaleY = 0.4;
		greenleaf_m.flipX = true;
		assessmentWalkthroughPanel_m.add(greenleaf_m);

		// interactiveOverlay_m
		const interactiveOverlay_m = this.add.image(0, 0, "1x1sprite");
		interactiveOverlay_m.scaleX = 1024;
		interactiveOverlay_m.scaleY = 768;
		interactiveOverlay_m.setOrigin(0, 0);
		interactiveOverlay_m.alpha = 0.001;
		interactiveOverlay_m.alphaTopLeft = 0.001;
		interactiveOverlay_m.alphaTopRight = 0.001;
		interactiveOverlay_m.alphaBottomLeft = 0.001;
		interactiveOverlay_m.alphaBottomRight = 0.001;
		assessmentWalkthroughPanel_m.add(interactiveOverlay_m);

		// topRightOverlays_m
		const topRightOverlays_m = this.add.container(680, 0);
		topRightOverlays_m.scaleX = 0.75;
		topRightOverlays_m.scaleY = 0.75;
		assessmentWalkthroughPanel_m.add(topRightOverlays_m);

		// walkthroughPanel_4_m
		const walkthroughPanel_4_m = this.add.container(0, 0);
		walkthroughPanel_4_m.visible = false;
		topRightOverlays_m.add(walkthroughPanel_4_m);

		// audioButton_3_m
		const audioButton_3_m = this.add.image(-80, 64, "exit1-reveal_32");
		audioButton_3_m.scaleX = 2;
		audioButton_3_m.scaleY = 2;
		walkthroughPanel_4_m.add(audioButton_3_m);

		// guidanceArrow_2_m
		const guidanceArrow_2_m = this.add.image(-75, 128, "GuidanceArrow-Small");
		guidanceArrow_2_m.scaleX = 4;
		guidanceArrow_2_m.scaleY = 4;
		walkthroughPanel_4_m.add(guidanceArrow_2_m);

		// labelContainer_6
		const labelContainer_6 = this.add.container(-80, 163);
		walkthroughPanel_4_m.add(labelContainer_6);

		// textBacking_6
		const textBacking_6 = this.add.nineslice(0, 2, "fadeOut2", undefined, 28, 0, 3, 3, 0, 0);
		textBacking_6.scaleX = 4;
		textBacking_6.scaleY = 32;
		textBacking_6.setOrigin(0.5, 0);
		textBacking_6.alpha = 0.5;
		textBacking_6.tint = 3023407;
		labelContainer_6.add(textBacking_6);

		// dailiesLabel_m_6
		const dailiesLabel_m_6 = this.add.bitmapText(0, 0, "Aronui", "Quit");
		dailiesLabel_m_6.setOrigin(0.5, 0);
		dailiesLabel_m_6.tintTopLeft = 15130076;
		dailiesLabel_m_6.tintTopRight = 15130076;
		dailiesLabel_m_6.tintBottomLeft = 15130076;
		dailiesLabel_m_6.tintBottomRight = 15130076;
		dailiesLabel_m_6.text = "Quit";
		dailiesLabel_m_6.fontSize = -28;
		labelContainer_6.add(dailiesLabel_m_6);

		// walkthroughPanel_5_m
		const walkthroughPanel_5_m = this.add.container(0, 0);
		walkthroughPanel_5_m.visible = false;
		topRightOverlays_m.add(walkthroughPanel_5_m);

		// audioButton_5_m
		const audioButton_5_m = this.add.image(-152, 64, "help-reveal_32");
		audioButton_5_m.scaleX = 2;
		audioButton_5_m.scaleY = 2;
		walkthroughPanel_5_m.add(audioButton_5_m);

		// guidanceArrow_6_m
		const guidanceArrow_6_m = this.add.image(-149, 128, "GuidanceArrow-Small");
		guidanceArrow_6_m.scaleX = 4;
		guidanceArrow_6_m.scaleY = 4;
		walkthroughPanel_5_m.add(guidanceArrow_6_m);

		// labelContainer
		const labelContainer = this.add.container(-149, 160);
		walkthroughPanel_5_m.add(labelContainer);

		// textBacking
		const textBacking = this.add.nineslice(0, 2, "fadeOut2", undefined, 32, 0, 3, 3, 0, 0);
		textBacking.scaleX = 4;
		textBacking.scaleY = 32;
		textBacking.setOrigin(0.5, 0);
		textBacking.alpha = 0.5;
		textBacking.tint = 3023407;
		labelContainer.add(textBacking);

		// dailiesLabel_m
		const dailiesLabel_m = this.add.bitmapText(0, 0, "Aronui", "Help");
		dailiesLabel_m.setOrigin(0.5, 0);
		dailiesLabel_m.tintTopLeft = 15130076;
		dailiesLabel_m.tintTopRight = 15130076;
		dailiesLabel_m.tintBottomLeft = 15130076;
		dailiesLabel_m.tintBottomRight = 15130076;
		dailiesLabel_m.text = "Help";
		dailiesLabel_m.fontSize = -28;
		labelContainer.add(dailiesLabel_m);

		// walkthroughPanel_6_m
		const walkthroughPanel_6_m = this.add.container(0, 0);
		walkthroughPanel_6_m.visible = false;
		topRightOverlays_m.add(walkthroughPanel_6_m);

		// audioButton_4_m
		const audioButton_4_m = this.add.image(-224, 64, "keyboard-click-reveal_32");
		audioButton_4_m.scaleX = 2;
		audioButton_4_m.scaleY = 2;
		walkthroughPanel_6_m.add(audioButton_4_m);

		// guidanceArrow_3_m
		const guidanceArrow_3_m = this.add.image(-224, 128, "GuidanceArrow-Small");
		guidanceArrow_3_m.scaleX = 4;
		guidanceArrow_3_m.scaleY = 4;
		walkthroughPanel_6_m.add(guidanceArrow_3_m);

		// labelContainer_1
		const labelContainer_1 = this.add.container(-224, 160);
		walkthroughPanel_6_m.add(labelContainer_1);

		// textBacking_1
		const textBacking_1 = this.add.nineslice(0, 2, "fadeOut2", undefined, 64, 0, 3, 3, 0, 0);
		textBacking_1.scaleX = 4;
		textBacking_1.scaleY = 32;
		textBacking_1.setOrigin(0.5, 0);
		textBacking_1.alpha = 0.5;
		textBacking_1.tint = 3023407;
		labelContainer_1.add(textBacking_1);

		// dailiesLabel_m_1
		const dailiesLabel_m_1 = this.add.bitmapText(0, 0, "Aronui", "Switch Controls");
		dailiesLabel_m_1.setOrigin(0.5, 0);
		dailiesLabel_m_1.tintTopLeft = 15130076;
		dailiesLabel_m_1.tintTopRight = 15130076;
		dailiesLabel_m_1.tintBottomLeft = 15130076;
		dailiesLabel_m_1.tintBottomRight = 15130076;
		dailiesLabel_m_1.text = "Switch Controls";
		dailiesLabel_m_1.fontSize = -28;
		labelContainer_1.add(dailiesLabel_m_1);

		// boardOverlays_m
		const boardOverlays_m = this.add.container(339, 376);
		boardOverlays_m.scaleX = 0.75;
		boardOverlays_m.scaleY = 0.75;
		assessmentWalkthroughPanel_m.add(boardOverlays_m);

		// walkthroughPanel_3_m
		const walkthroughPanel_3_m = this.add.container(-800, -1024);
		walkthroughPanel_3_m.visible = false;
		boardOverlays_m.add(walkthroughPanel_3_m);

		// audioButton_6_m
		const audioButton_6_m = this.add.image(728, 968, "ui-speak-button");
		audioButton_6_m.scaleX = 4;
		audioButton_6_m.scaleY = 4;
		walkthroughPanel_3_m.add(audioButton_6_m);

		// guidanceArrow_7_m
		const guidanceArrow_7_m = this.add.image(728, 896, "GuidanceArrow-Small");
		guidanceArrow_7_m.scaleX = 4;
		guidanceArrow_7_m.scaleY = 4;
		guidanceArrow_7_m.flipY = true;
		walkthroughPanel_3_m.add(guidanceArrow_7_m);

		// labelContainer_2
		const labelContainer_2 = this.add.container(729, 832);
		walkthroughPanel_3_m.add(labelContainer_2);

		// textBacking_2
		const textBacking_2 = this.add.nineslice(0, 2, "fadeOut2", undefined, 92, 0, 3, 3, 0, 0);
		textBacking_2.scaleX = 4;
		textBacking_2.scaleY = 32;
		textBacking_2.setOrigin(0.5, 0);
		textBacking_2.alpha = 0.5;
		textBacking_2.tint = 3023407;
		labelContainer_2.add(textBacking_2);

		// dailiesLabel_m_2
		const dailiesLabel_m_2 = this.add.bitmapText(0, 0, "Aronui", "Hear Word in Sentence");
		dailiesLabel_m_2.setOrigin(0.5, 0);
		dailiesLabel_m_2.tintTopLeft = 15130076;
		dailiesLabel_m_2.tintTopRight = 15130076;
		dailiesLabel_m_2.tintBottomLeft = 15130076;
		dailiesLabel_m_2.tintBottomRight = 15130076;
		dailiesLabel_m_2.text = "Hear Word in Sentence";
		dailiesLabel_m_2.fontSize = -28;
		labelContainer_2.add(dailiesLabel_m_2);

		// walkthroughPanel_2_m
		const walkthroughPanel_2_m = this.add.container(-800, -1024);
		walkthroughPanel_2_m.visible = false;
		boardOverlays_m.add(walkthroughPanel_2_m);

		// audioButton_7_m
		const audioButton_7_m = this.add.image(800, 968, "ui-definition-button");
		audioButton_7_m.scaleX = 4;
		audioButton_7_m.scaleY = 4;
		walkthroughPanel_2_m.add(audioButton_7_m);

		// guidanceArrow_8_m
		const guidanceArrow_8_m = this.add.image(800, 896, "GuidanceArrow-Small");
		guidanceArrow_8_m.scaleX = 4;
		guidanceArrow_8_m.scaleY = 4;
		guidanceArrow_8_m.flipY = true;
		walkthroughPanel_2_m.add(guidanceArrow_8_m);

		// labelContainer_3
		const labelContainer_3 = this.add.container(801, 832);
		walkthroughPanel_2_m.add(labelContainer_3);

		// textBacking_3
		const textBacking_3 = this.add.nineslice(0, 2, "fadeOut2", undefined, 64, 0, 3, 3, 0, 0);
		textBacking_3.scaleX = 4;
		textBacking_3.scaleY = 32;
		textBacking_3.setOrigin(0.5, 0);
		textBacking_3.alpha = 0.5;
		textBacking_3.tint = 3023407;
		labelContainer_3.add(textBacking_3);

		// dailiesLabel_m_3
		const dailiesLabel_m_3 = this.add.bitmapText(0, 0, "Aronui", "Hear Definition");
		dailiesLabel_m_3.setOrigin(0.5, 0);
		dailiesLabel_m_3.tintTopLeft = 15130076;
		dailiesLabel_m_3.tintTopRight = 15130076;
		dailiesLabel_m_3.tintBottomLeft = 15130076;
		dailiesLabel_m_3.tintBottomRight = 15130076;
		dailiesLabel_m_3.text = "Hear Definition";
		dailiesLabel_m_3.fontSize = -28;
		labelContainer_3.add(dailiesLabel_m_3);

		// walkthroughPanel_1_m
		const walkthroughPanel_1_m = this.add.container(-800, -1024);
		walkthroughPanel_1_m.visible = false;
		boardOverlays_m.add(walkthroughPanel_1_m);

		// audioButton_8_m
		const audioButton_8_m = this.add.image(880, 968, "ui-repeat-button");
		audioButton_8_m.scaleX = 4;
		audioButton_8_m.scaleY = 4;
		walkthroughPanel_1_m.add(audioButton_8_m);

		// guidanceArrow_9_m
		const guidanceArrow_9_m = this.add.image(880, 896, "GuidanceArrow-Small");
		guidanceArrow_9_m.scaleX = 4;
		guidanceArrow_9_m.scaleY = 4;
		guidanceArrow_9_m.flipY = true;
		walkthroughPanel_1_m.add(guidanceArrow_9_m);

		// labelContainer_4
		const labelContainer_4 = this.add.container(879, 832);
		walkthroughPanel_1_m.add(labelContainer_4);

		// textBacking_4
		const textBacking_4 = this.add.nineslice(0, 2, "fadeOut2", undefined, 54, 0, 3, 3, 0, 0);
		textBacking_4.scaleX = 4;
		textBacking_4.scaleY = 32;
		textBacking_4.setOrigin(0.5, 0);
		textBacking_4.alpha = 0.5;
		textBacking_4.tint = 3023407;
		labelContainer_4.add(textBacking_4);

		// dailiesLabel_m_4
		const dailiesLabel_m_4 = this.add.bitmapText(0, 0, "Aronui", "Repeat Word");
		dailiesLabel_m_4.setOrigin(0.5, 0);
		dailiesLabel_m_4.tintTopLeft = 15130076;
		dailiesLabel_m_4.tintTopRight = 15130076;
		dailiesLabel_m_4.tintBottomLeft = 15130076;
		dailiesLabel_m_4.tintBottomRight = 15130076;
		dailiesLabel_m_4.text = "Repeat Word";
		dailiesLabel_m_4.fontSize = -28;
		labelContainer_4.add(dailiesLabel_m_4);

		// walkthroughPanel_m
		const walkthroughPanel_m = this.add.container(-800, -1024);
		boardOverlays_m.add(walkthroughPanel_m);

		// guidanceArrow_10_m
		const guidanceArrow_10_m = this.add.image(800, 840, "GuidanceArrow-Small");
		guidanceArrow_10_m.scaleX = 4;
		guidanceArrow_10_m.scaleY = 4;
		guidanceArrow_10_m.flipY = true;
		walkthroughPanel_m.add(guidanceArrow_10_m);

		// image
		const image = this.add.image(800, 908, "default-button-confirm");
		image.scaleX = 2;
		image.scaleY = 2;
		walkthroughPanel_m.add(image);

		// submitLabel_m
		const submitLabel_m = this.add.bitmapText(801, 909, "Aronui", "Submit");
		submitLabel_m.setOrigin(0.5, 0.5);
		submitLabel_m.tintTopLeft = 15130076;
		submitLabel_m.tintTopRight = 15130076;
		submitLabel_m.tintBottomLeft = 15130076;
		submitLabel_m.tintBottomRight = 15130076;
		submitLabel_m.text = "Submit";
		submitLabel_m.fontSize = -14;
		walkthroughPanel_m.add(submitLabel_m);

		// labelContainer_5
		const labelContainer_5 = this.add.container(801, 776);
		walkthroughPanel_m.add(labelContainer_5);

		// textBacking_5
		const textBacking_5 = this.add.nineslice(0, 2, "fadeOut2", undefined, 54, 0, 3, 3, 0, 0);
		textBacking_5.scaleX = 4;
		textBacking_5.scaleY = 32;
		textBacking_5.setOrigin(0.5, 0);
		textBacking_5.alpha = 0.5;
		textBacking_5.tint = 3023407;
		labelContainer_5.add(textBacking_5);

		// dailiesLabel_m_5
		const dailiesLabel_m_5 = this.add.bitmapText(0, 0, "Aronui", "Submit Word");
		dailiesLabel_m_5.setOrigin(0.5, 0);
		dailiesLabel_m_5.tintTopLeft = 15130076;
		dailiesLabel_m_5.tintTopRight = 15130076;
		dailiesLabel_m_5.tintBottomLeft = 15130076;
		dailiesLabel_m_5.tintBottomRight = 15130076;
		dailiesLabel_m_5.text = "Submit Word";
		dailiesLabel_m_5.fontSize = -28;
		labelContainer_5.add(dailiesLabel_m_5);

		// continueButtonContainer_m
		const continueButtonContainer_m = this.add.container(680, 376);
		continueButtonContainer_m.scaleX = 0.75;
		continueButtonContainer_m.scaleY = 0.75;
		assessmentWalkthroughPanel_m.add(continueButtonContainer_m);

		// continueButton_m
		const continueButton_m = new DefaultConfirmButton_m(this, -120, -48);
		continueButtonContainer_m.add(continueButton_m);

		// continueButton (prefab fields)
		continueButton.buttonText = "Next";

		// continueButton_m (prefab fields)
		continueButton_m.buttonText = "Next";

		this.greenleaf = greenleaf;
		this.interactiveOverlay = interactiveOverlay;
		this.walkthroughPanel_4 = walkthroughPanel_4;
		this.walkthroughPanel_5 = walkthroughPanel_5;
		this.walkthroughPanel_6 = walkthroughPanel_6;
		this.topRightOverlays = topRightOverlays;
		this.walkthroughPanel_3 = walkthroughPanel_3;
		this.walkthroughPanel_2 = walkthroughPanel_2;
		this.walkthroughPanel_1 = walkthroughPanel_1;
		this.walkthroughPanel = walkthroughPanel;
		this.boardOverlays = boardOverlays;
		this.continueButton = continueButton;
		this.continueButtonContainer = continueButtonContainer;
		this.assessmentWalkthroughPanel = assessmentWalkthroughPanel;
		this.desktopView = desktopView;
		this.greenleaf_m = greenleaf_m;
		this.interactiveOverlay_m = interactiveOverlay_m;
		this.walkthroughPanel_4_m = walkthroughPanel_4_m;
		this.walkthroughPanel_5_m = walkthroughPanel_5_m;
		this.walkthroughPanel_6_m = walkthroughPanel_6_m;
		this.topRightOverlays_m = topRightOverlays_m;
		this.walkthroughPanel_3_m = walkthroughPanel_3_m;
		this.walkthroughPanel_2_m = walkthroughPanel_2_m;
		this.walkthroughPanel_1_m = walkthroughPanel_1_m;
		this.walkthroughPanel_m = walkthroughPanel_m;
		this.boardOverlays_m = boardOverlays_m;
		this.continueButton_m = continueButton_m;
		this.continueButtonContainer_m = continueButtonContainer_m;
		this.assessmentWalkthroughPanel_m = assessmentWalkthroughPanel_m;
		this.mobileView = mobileView;
		this.mainContainer = mainContainer;

		this.events.emit("scene-awake");
	}

	private greenleaf!: Phaser.GameObjects.Image;
	private interactiveOverlay!: Phaser.GameObjects.Image;
	private walkthroughPanel_4!: Phaser.GameObjects.Container;
	private walkthroughPanel_5!: Phaser.GameObjects.Container;
	private walkthroughPanel_6!: Phaser.GameObjects.Container;
	private topRightOverlays!: Phaser.GameObjects.Container;
	private walkthroughPanel_3!: Phaser.GameObjects.Container;
	private walkthroughPanel_2!: Phaser.GameObjects.Container;
	private walkthroughPanel_1!: Phaser.GameObjects.Container;
	private walkthroughPanel!: Phaser.GameObjects.Container;
	private boardOverlays!: Phaser.GameObjects.Container;
	public continueButton!: DefaultButton;
	private continueButtonContainer!: Phaser.GameObjects.Container;
	private assessmentWalkthroughPanel!: Phaser.GameObjects.Container;
	public desktopView!: Phaser.GameObjects.Container;
	private greenleaf_m!: Phaser.GameObjects.Image;
	private interactiveOverlay_m!: Phaser.GameObjects.Image;
	private walkthroughPanel_4_m!: Phaser.GameObjects.Container;
	private walkthroughPanel_5_m!: Phaser.GameObjects.Container;
	private walkthroughPanel_6_m!: Phaser.GameObjects.Container;
	private topRightOverlays_m!: Phaser.GameObjects.Container;
	private walkthroughPanel_3_m!: Phaser.GameObjects.Container;
	private walkthroughPanel_2_m!: Phaser.GameObjects.Container;
	private walkthroughPanel_1_m!: Phaser.GameObjects.Container;
	private walkthroughPanel_m!: Phaser.GameObjects.Container;
	private boardOverlays_m!: Phaser.GameObjects.Container;
	public continueButton_m!: DefaultConfirmButton_m;
	private continueButtonContainer_m!: Phaser.GameObjects.Container;
	private assessmentWalkthroughPanel_m!: Phaser.GameObjects.Container;
	public mobileView!: Phaser.GameObjects.Container;
	private mainContainer!: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  // Write your code here

  private walkthroughController?: WalkthroughController;
  private hasRun: boolean = false;

  preload() {
    // Intro.
    this.load.audio(
      `walkthrough-switch-controls`,
      `game_assets/audio/mentors/walkthroughs/walkthrough-switch-controls.mp3`,
    );
    this.load.audio(
      `walkthrough-submit-word`,
      `game_assets/audio/mentors/walkthroughs/walkthrough-submit-word.mp3`,
    );
    this.load.audio(
      `walkthrough-repeat-word`,
      `game_assets/audio/mentors/walkthroughs/walkthrough-repeat-word.mp3`,
    );
    this.load.audio(
      `walkthrough-quit`,
      `game_assets/audio/mentors/walkthroughs/walkthrough-quit.mp3`,
    );
    this.load.audio(
      `walkthrough-switch-controls`,
      `game_assets/audio/mentors/walkthroughs/walkthrough-switch-controls.mp3`,
    );
    this.load.audio(
      `walkthrough-help`,
      `game_assets/audio/mentors/walkthroughs/walkthrough-help.mp3`,
    );
    this.load.audio(
      `walkthrough-hear-word-in-sentence`,
      `game_assets/audio/mentors/walkthroughs/walkthrough-hear-word-in-sentence.mp3`,
    );
    this.load.audio(
      `walkthrough-hear-word-definition`,
      `game_assets/audio/mentors/walkthroughs/walkthrough-hear-word-definition.mp3`,
    );
  }

  create() {
    this.editorCreate();

    const audioKeys = [
      'walkthrough-submit-word',
      'walkthrough-repeat-word',
      'walkthrough-hear-word-definition',
      'walkthrough-hear-word-in-sentence',
      'walkthrough-quit',
      'walkthrough-help',
      'walkthrough-switch-controls',
    ];

    const slides = [
      this.walkthroughPanel,
      this.walkthroughPanel_1,
      this.walkthroughPanel_2,
      this.walkthroughPanel_3,
      this.walkthroughPanel_4,
      this.walkthroughPanel_5,
      this.walkthroughPanel_6,
    ];

    const slides_m = [
      this.walkthroughPanel_m,
      this.walkthroughPanel_1_m,
      this.walkthroughPanel_2_m,
      this.walkthroughPanel_3_m,
      this.walkthroughPanel_4_m,
      this.walkthroughPanel_5_m,
      this.walkthroughPanel_6_m,
    ];

    this.walkthroughController = new WalkthroughController({
      parent: this.mainContainer,
      audioKeys,
      slides,
      slides_m,
      continueButton: this.continueButton,
      continueButton_m: this.continueButton_m,
      responsiveOverlay: this.interactiveOverlay,
      responsiveOverlay_m: this.interactiveOverlay_m,
    });

    this.walkthroughController.onWalkthroughComplete = () => {
      if (!this.hasRun) {
        getSceneManager()?.pauseScene('AssessmentWalkthroughPanel');
        EventBus.emit(GAME_EVENTS.ASSESSMENT_WALKTHROUGH_COMPLETED);
        this.hasRun = true;
      }
    };
    this.continueButton.controller.setSubmissionCallback(() => {
      this.walkthroughController?.progressWalkthrough();
    });

    this.initializeResponsiveness();
  }

  start() {
    this.walkthroughController?.initialize();
  }

  reset() {
    this.walkthroughController?.reset();
  }

  initializeResponsiveness() {
    const anchor = getAnchorPlugin(this);

    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });

    // Desktop.
    anchor.add(this.assessmentWalkthroughPanel, {
      left: '0%',
      top: '0%',
    });
    anchor.add(this.interactiveOverlay, {
      width: '100%',
      height: '100%',
    });
    anchor.add(this.topRightOverlays, {
      right: '100%',
    });
    anchor.add(this.boardOverlays, {
      centerX: '50%',
      bottom: `100%`,
    });
    anchor.add(this.greenleaf, {
      right: '90%',
      bottom: '100%+100',
    });
    anchor.add(this.continueButtonContainer, {
      right: '100%',
      bottom: '100%',
    });

    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.boardOverlays,
      DEFAULT_SCALE_DOWN_CONFIG,
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.topRightOverlays,
      DEFAULT_SCALE_DOWN_CONFIG,
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.greenleaf, {
      ...DEFAULT_SCALE_DOWN_CONFIG,
      scaleModifier: 0.4,
    });
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.boardOverlays,
      DEFAULT_SCALE_DOWN_CONFIG,
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.topRightOverlays,
      DEFAULT_SCALE_DOWN_CONFIG,
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.greenleaf, {
      ...DEFAULT_SCALE_DOWN_CONFIG,
      scaleModifier: 0.4,
    });

    // Mobile.
    anchor.add(this.assessmentWalkthroughPanel_m, {
      left: '0%',
      top: '0%',
    });
    anchor.add(this.interactiveOverlay_m, {
      width: '100%',
      height: '100%',
    });
    anchor.add(this.topRightOverlays_m, {
      right: '100%',
    });
    anchor.add(this.boardOverlays_m, {
      centerX: '50%',
      bottom: `100%`,
    });
    anchor.add(this.greenleaf_m, {
      left: '10%',
      bottom: '100%+350',
    });
    anchor.add(this.continueButtonContainer_m, {
      right: '100%',
      bottom: '100%',
    });

    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.boardOverlays_m,
      { scaleModifier: 0.5 },
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.topRightOverlays_m,
      { scaleModifier: 0.5 },
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.greenleaf_m, {
      scaleModifier: 0.4,
    });

    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.boardOverlays_m,
      { scaleModifier: 0.5 },
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(
      this.topRightOverlays_m,
      { scaleModifier: 0.5 },
    );
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.greenleaf_m, {
      scaleModifier: 0.4,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
